import axios from "axios";

export const authService = {
    login,
    logout
};

function login({username, password, access_token, type, product}) {
    delete axios.defaults.headers.common["Authorization"];
    return axios
        .post(`${process.env.VUE_APP_API_URL}/login`, {username, password, access_token, type, product})
        .then(function (data) {
            if (data) {
                //alert(data);
                    //let data = JSON.parse(data2)
                    localStorage.setItem("user", JSON.stringify(data));
                    axios.defaults.headers.common["Authorization"] = "Bearer " + data.token;
                    return data;
                    /*
                    localStorage.setItem("token", JSON.stringify(data));
                    axios.defaults.headers.common["Authorization"] = "Bearer " + data.access_token;
                    return axios.get(`${process.env.VUE_APP_API_URL}/profile`, {  })
                        .then(function (data) {
                            if (data) {
                                //data.userId = data.id;
                                localStorage.setItem("user", JSON.stringify(data));
                                return data;
                            }
                        });

                     */
                }
            },
            error => {
            console.log(error);
            });
}

function logout() {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    axios.defaults.headers.common["Authorization"] = null;
    delete axios.defaults.headers.common["Authorization"];
}
